<div class="container-fluid py-4">
  <div class="row">
    @for (menu of menuData; track menu.route) {
      <app-menu-item [menuItem]="menu"></app-menu-item>
    }
  </div>
</div>
